const messagesAR = {
    code: "ar",
    messages: {
        alpha: (field) => `${field} يمكن أن تحتوي على أحرف فقط`,
        alpha_dash: (field) => `${field} يمكن أن يحتوي الحقل على أحرف وواصلات (-) أو شرطات سفلية (_) `,
        alpha_num: (field) => `${field} يمكن أن تحتوي على أحرف وأرقام فقط`,
        alpha_spaces: (field) => `${field} يمكن أن تحتوي الأحرف فقط على مسافات `,
        between: (field, min, max) => `${field} ${min} مع ${max} يجب أن يكون في النطاق `,
        confirmed: (field) => `${field} التحقق خاطئ `,
        digits: (field, length) => `${field} العددية و ${length} يجب أن تصعد `,
        dimensions: (field, width, height) => `${field} منطقة ${width} مع بكسل ${height} يجب أن يكون بين البكسل `,
        email: (field) => `${field} يجب أن يكون الحقل بريدًا إلكترونيًا صالحًا `,
        excluded: (field) => `${field} أدخل قيمة صالحة في الحقل `,
        ext: (field) => `${field} يجب أن يكون الحقل ملفًا صالحًا `,
        image: (field) => `${field} يجب أن يكون الحقل ملف صورة `,
        oneOf: (field) => `${field} أدخل قيمة صالحة في الحقل `,
        max: (field, length) => `${field} منطقة ${length} ليس أكثر من حرف واحد `,
        max_value: (field, max) => `${field} منطقة ${max} يجب أن تكون قيمة أو أقل `,
        mimes: (field) => `${field} يجب أن يكون ملفًا صالحًا `,
        min: (field, length) => `${field} المنطقة على الأقل ${length} يجب إدخال الحرف `,
        min_value: (field, min) => `${field} منطقة ${min} يجب أن تكون قيمة أو أكثر `,
        numeric: (field) => `${field} أدخل قيمة رقمية في الحقل `,
        regex: (field) => `${field} التنسيق غير صالح `,
        required: (field) => `${field} المساحة المطلوبة `,
        required_if: (field) => `${field} المساحة المطلوبة `,
        size: (field, size) => `${field} منطقة ${size} أن يكون أقل من كيلو بايت `,
    },
};

export default messagesAR;



// WEBPACK FOOTER //
// ./src/language/validationMessagesAR.js